<template>
  <div class="sn-f-b-s record">
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s record-region">
      <div class="sn-f-1 sn-f-s-1 record-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>就诊人：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <div v-else-if="patientArray.length === 0" @click="navigateUrl('addition-patient');">
              暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
            </div>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div v-if="cardType === '1'">{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
              <div v-else>住院号：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">-</div>
          <div class="sn-f-s-c region">
            <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(handleRecord)">
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>身份证号</th>
                  <th>支付类型</th>
                  <th>充值金额（元）</th>
                  <th>充值时间</th>
                  <th>卡类型</th>
                  <th>流水号</th>
                  <th>状态</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="record.feeId" v-for="(record, index) in handleRecord">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{selectedPatient.idCardEncrypt}}</td>
                  <td>{{record.payType}}</td>
                  <!-- 院方是否提供门诊充值记录接口 -->
                  <td v-if="$sn.getConfig('isHospitalSupportRechargeList')">{{record.totalCost === 0 ? '0.00' : $sn.format.priceFormat(record.totalCost, 2)}}</td>
                  <td v-else>{{record.totalFee === 0 ? '0.00' : $sn.format.priceFormat(record.totalFee, 2)}}</td>
                  <td>{{$sn.getConfig('isHospitalSupportRechargeList') ? record.optime : record.createTime}}</td>
                  <td>{{$sn.getConfig('isHospitalSupportRechargeList') ? record.serviceType : $sn.getConfig('outRechargeLabel')}}</td>
                  <td>
                    <el-popover trigger="hover" v-if="record.outTradeNo">
                      {{record.outTradeNo}}
                      <el-button class="tradeNo-button" slot="reference">
                        {{record.outTradeNo.substr(0, 3) + '***' + record.outTradeNo.substr(record.outTradeNo.length - 3, 3)}}
                      </el-button>
                    </el-popover>
                  </td>
                  <td v-if="$sn.getConfig('isHospitalSupportRechargeList')">成功</td>
                  <td v-else>{{record.tradeStatus === '1' ? '成功' : '失败'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <div class="sn-f-c-c prompt-message">
            {{ `列表仅显示两个月内${$sn.getConfig('outRechargeLabel')}记录、更多记录请按时间筛选查询` }}
          </div>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(recordInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard"  :type="isOpenSingleCard ? '1' : cardType" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Constants from '@/common/utils/constants';

export default {
  mixins: [PatientShareMixin, HomepageMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  data() {
    return {
      cardType: '1',
      patientArray: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('pcPrescriptionDateRange')[0], self.$sn.getConfig('pcPrescriptionDateRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard'),
      recordInfo: [],
      pageCount: 1,
      isResult: true,
      totalCost: 0,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false
    };
  },
  computed: {
    // 充值记录
    handleRecord() {
      let handle = [];
      if (this.recordInfo.length > 0) handle = this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      handle.forEach(item => {
        if (!this.$sn.getConfig('isHospitalSupportRechargeList')) {
          const type = {
            '1': '支付宝',
            '2': '微信'
          };
          item.payType = type[item.payType] || '其他';
        }
      });
      return handle;
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.recordInfo = [];
      this.pageCount = 1;
      // 门诊
      let type = Constants.OUT_CARD_CLINIC_TYPE;
      // 住院
      if (this.cardType === '2') {
        type = Constants.IN_CARD_CLINIC_TYPE;
      }
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient, type);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) this.outCardSerialFormat = patient.idCardEncrypt;
        }
        if (this.outCardSerial) this.searchBtn();
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) this.navigateUrl('addition-card');
            }
          });
        }
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.searchBtn();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.cardType = this.$route.query.type || '1';
    document.title = `${this.$sn.getConfig('outRechargeLabel')}记录`;
    this.$route.meta.title = `${this.$sn.getConfig('outRechargeLabel')}记录`;
    if (this.cardType === '2') {
      document.title = '住院充值记录';
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', Constants.FUNCTION_ID_ZYCZ);
    }
    this.handlePatientInfo();
  },
  methods: {
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.cardType === '2' && this.hosId !== this.perpetual.HOSPITAL_ID_SDQL) {
        // 住院人 - 含有住院号
        if (!this.isOpenSingleCard) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      if (this.patientArray && this.patientArray.length > 0) {
        if (this.cardType === '1') {
          this.selectedPatient = this.$sn.utils.getCurrentPatient();
        }
        else {
          if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
          else this.selectedPatient = this.patientArray.find(item => item.inCardNo) || this.patientArray[0];
        }
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询充值记录
    searchBtn() {
      if (!this.outCardSerial) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
        };
        this.$sn.assembly.modal({
          caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
          success: (modal) => {
            if (modal.confirm) this.navigateUrl('addition-card');
          }
        });
      }
      else {
        if (this.$sn.validate.empty(this.startDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
          return false;
        }
        if (this.$sn.validate.empty(this.endDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
          return false;
        }
        const start = new Date(this.startDate).getTime();
        const end = new Date(this.endDate).getTime();
        if (end < start) {
          this.getShowToast('结束日期不能早于开始日期');
          return false;
        }
        // 院方是否提供门诊充值记录接口
        if (this.$sn.getConfig('isHospitalSupportRechargeList')) {
          const params = {
            url: Swagger.getHospitalRechargeRecordTable,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              hosId: this.$sn.utils.getHospitalId(),
              platformId: this.$sn.utils.getPlatformType(),
              platformUserId: this.$sn.utils.getOpenId(),
              projectType: this.$sn.utils.getProjectType(),
              cardNo: this.outCardSerial,
              patId: this.selectedPatient.patientId,
              idCardNo: this.selectedPatient.patientIdCardNo,
              cardType: this.cardType, // 卡类型 1门诊卡 2住院卡
              payType: '', // 支付途径1支付宝 2微信 3其他
              serviceType: '0', // 业务类型0就诊卡充值1挂号费支付2自助缴费3住院预交金充值4其他5体检支付
              patName: this.selectedPatient.patientName,
              size: this.perpetual.PAGINATION_SIZE,
              page: this.pageCount,
              startDate: this.startDate,
              endDate: this.endDate
            })
          };
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            if (result && result.code === 0 && result.data && result.data.length > 0) {
              this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
              if (this.pageCount === 1) {
                this.recordInfo = result.data;
                this.totalCost = result.totalFee || 0;
              }
              else this.recordInfo = this.recordInfo.concat(result.data);
            }
            else this.isResult = false;
          });
        }
        else {
          const params = {
            url: this.$sn.format.caption(Swagger.getRechargeRecordTable, [this.selectedPatient.patientId, this.startDate, this.endDate]),
            method: 'POST',
            header: true,
            data: JSON.stringify({})
          };
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            if (result && result.code === 0 && result.data && result.data.length > 0) {
              this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
              if (this.pageCount === 1) {
                this.recordInfo = result.data;
                this.totalCost = result.totalFee || 0;
              }
              else this.recordInfo = this.recordInfo.concat(result.data);
            }
            else this.isResult = false;
          });
        }
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.record {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .record-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        .el-button {
          padding: 10px 20px;
          background-color: $main1;
          border-color: $main1;
        }
      }

      .sn-table {
        .tradeNo-button {
          color: $text1;
          width: 100%;
          font-size: 16px;
          border: none;
          background-color: transparent;

          &:hover {
            color: $main3;
          }
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
